<script>
export default {
    name: "RegisterCover",
}
</script>
<template>
    
    <tail-base-layout>
        <template v-slot:breadcrum>
            <li>Organization/Insurance Companies</li>
        </template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <div class="flex w-full md:flex-row sm:flex-col">
                  <h5 class="flex-1 font-medium">Organization/ Insurance Companies</h5>
                </div>
              </template>
              <template v-slot:card-body>
                  <div class="flex flex-wrap border bg-indigo-300 mb-1">
                        <div class="md:w-1/4 sm:w-full">
                            <h5 class="text-center font-bold">Patient Name:</h5>
                        </div>
                        <div class="md:w-1/4 sm:w-full">
                            <h5 class="text-center font-bold">In-Patient File No:</h5>
                        </div>
                        <div class="md:w-1/4 sm:w-full">
                            <h5 class="text-center font-bold">Out-Patient File No:</h5>
                        </div>
                        <div class="md:w-1/4 sm:w-full">
                            <h5 class="text-center font-bold">Registered On:</h5>
                        </div>
                  </div>
                  <div class="flex flex-wrap border mb-1">
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-insurance" class="label-control">Insurance</label>
                          <select id="grid-insurance" class="input-sm input-control text-xs">
                              <option value=""></option>
                          </select>
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-type-of-cover" class="label-control">Type of cover</label>
                          <select id="grid-type-of-cover" class="input-sm input-control text-xs">
                              <option value=""></option>
                          </select>
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-dependant" class="label-control">Dependant:</label>
                          <select id="grid-dependant" class="input-sm input-control text-xs">
                              <option value=""></option>
                          </select>
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-member-no" class="label-control">Member No:</label>
                          <input type="text" id="grid-member-no" class="input-sm input-control text-xs">
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-confirm-member-no" class="label-control">Confirm Member No:</label>
                          <input type="text" id="grid-confirm-member-no" class="input-sm input-control text-xs">
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-id-no" class="label-control">ID No:</label>
                          <input type="text" id="grid-id-no" class="input-sm input-control text-xs">
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-confirm-id-no" class="label-control">Confirm ID No:</label>
                          <input type="text" id="grid-confirm-id-no" class="input-sm input-control text-xs">
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2">
                          <label for="grid-employer" class="label-control">Employer:</label>
                          <input type="text" id="grid-employer" class="input-sm input-control text-xs">
                      </div>
                      <div class="md:w-1/5 sm:w-full p-2 pt-3">
                          <label for="grid-is-active" class="label-control mt-4">Is Active <input type="checkbox" id="grid-is-active"></label>
                      </div>
                      <div class="w-full p-1 bg-gray-200 flex justify-end border">
                          <button class="btn-sm btn-primary text-sm"><i class="fa fa-plus"></i> Record</button>
                      </div>
                  </div>
                  <table class="table table-bordered">
                      <tr>
                          <th>ID</th>
                          <th>Organization</th>
                          <th>Member No</th>
                          <th>Principal Dependant</th>
                          <th>ID No</th>
                          <th>Rebate</th>
                          <th>Active</th>
                          <th>Action</th>
                      </tr>
                      <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                      </tr>
                  </table>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>

